export default     {
    prompt:"Heading Color",
    field:"--headingColor",
    type:"style",
    colorPicker:true,
    default:'#000000ff'
}